angular.module('logbook')
.directive('alertSelectorModal', ['$http', '$interval', '$location', '$rootScope', '$q', '$timeout', '$compile',
function($http, $interval, $location, $rootScope, $q, $timeout, $compile)
{
	return {
	    restrict: 'E',
		template: require('./alert-selector-modal.html'),
		scope: {
	    	onBind: '=',
			selectedLog: '=',
	    	onSelection: '=',
			filter: '=',
			queryParams: '='
		},
		
		link: function(scope, elem, attrs)
		{
			var $element = $(elem);

			scope.selectorBoundPromise = $q.defer();
			scope.buttonText = attrs.buttonText;
			scope.selectOne = attrs.hasOwnProperty('selectOne');
			scope.useLocal = true;


			scope.selectionMade = function(alert)
			{
				if (typeof scope.onSelection === 'function')
					scope.onSelection(alert);

				if (scope.selectOne)
					scope.toggleModal(false);
			};

			scope.toggleModal = function(isOpen, event)
			{
				var command = (isOpen) ? 'show' : 'hide';
				$('#alertSelectModal').modal(command);
			};

			scope.applyFilter = function()
			{
				scope.selectorScope.applyFilter();
			};

			scope.setQueryParameters = function(queryParameters)
			{
				if (scope.selectorScope)
					scope.selectorScope.queryParams = queryParameters;
			};

			scope.selectorBound = function(selectorScope)
			{
				scope.selectorScope = selectorScope;
				scope.selectorBoundPromise.resolve();
			};

			$(elem).find('#selector-body').html('<alert-selector selected-log="selectedLog" on-selection="selectionMade" filter="filter" on-bind="selectorBound" query-params="queryParams"></alert-selector>');

			var selectorElement = angular.element($(elem).find('#selector-body alert-selector'));
			$compile(selectorElement)(scope);

			scope.selectorBoundPromise.promise.then(function()
			{
				if (typeof scope.onBind === 'function')
					scope.onBind(scope);
			});


			Object.keys(attrs.$attr).forEach(function(key)
			{
				$element.find('#btn-alert-select').attr(key, attrs[key]);
			});
		}
	}
}]);